import { isPlatformBrowser } from '@angular/common';
import { Inject, Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';

@Pipe({
  name: 'base64'
})
export class Base64Pipe implements PipeTransform {
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  transform(url: string): any {
    if (this.isBrowser) {
      return encodeURIComponent(btoa(url));
    } else {
      const bf = Buffer.from(url);
      return bf.toString('base64');
    }
  }
}
